export const sendMessageToApp = (type: string, data?: any) => {
  const isServer = typeof window === 'undefined'

  //@ts-ignore
  if (!isServer && window && window.ReactNativeWebView) {
    //@ts-ignore
    window.ReactNativeWebView.postMessage(JSON.stringify({ type, data }))
  }
}